import React, { useMemo } from 'react';
import { BsCheck } from 'react-icons/bs';
import { useController, Control } from 'react-hook-form';
import styles from './checkbox.module.scss';

interface CheckboxProps {
  name: string,
  control: Control<any>,
  label?: React.ReactNode,
  className?: string,
  defaultValue?: boolean,
  inline?: boolean,
  rules?: any | null,
  style?: 'secondary',
  disabled?: boolean,
}

const Checkbox = ({
  name,
  control,
  label,
  className,
  inline = true,
  defaultValue = false,
  rules,
  style,
  disabled = false,
}: CheckboxProps) => {
  const { field: { value, onChange } } = useController({
    name,
    control,
    defaultValue,
    rules,
  });

  const classname = useMemo(() => {
    let computedClassName = styles.checkbox;
    if (inline) computedClassName += ` ${styles.inline}`;
    if (style) computedClassName += ` ${styles[style]}`;
    if (!value) computedClassName += ` ${styles.notchecked}`;
    if (disabled) computedClassName += ` ${styles.disabled}`;
    if (className) computedClassName += ` ${className}`;
    return computedClassName;
  }, [className, disabled, inline, style, value]);

  return (
    <div className={classname}>
      <div className={styles.container}>
        <div className={styles.square} onClick={() => {
          if (!disabled) onChange(!value);
        }}>
          {value && <BsCheck size={30} />}
        </div>
      </div>
      {label && (
        <label
          onClick={() => {
            if (!disabled) onChange(!value);
          }}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
